import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";

import { fetchChangePasswordAuthFailure, fetchChangePasswordAuthSuccess, fetchChangePasswordFailure, fetchChangePasswordSuccess } from "./actions";
import { FETCH_CHANGE_PASSWORD_AUTH_REQUEST, FETCH_CHANGE_PASSWORD_REQUEST } from "./actions.type";

import { fetchChangePasswordAuthService, fetchChangePasswordService } from "../services/change-password.service";
import { FetchChangePasswordAuthRequest, FetchChangePasswordRequest } from "./types";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";

function* fetchChangePasswordSaga(action: FetchChangePasswordRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchChangePasswordService());
    console.log("fetchChangePassword response: ", response);
    if (response.status === 200) {
      yield put(fetchChangePasswordSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    const msg = getErrorMessage(e, false);
    yield put(fetchChangePasswordFailure(msg));
  }
}

function* fetchChangePasswordAuthSaga(action: FetchChangePasswordAuthRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchChangePasswordAuthService(action));
    console.log("fetchChangePasswordAuth response: ", response);
    if (response.status === 200) {
      yield put(fetchChangePasswordAuthSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    const msg = getErrorMessage(e, false);
    yield put(fetchChangePasswordAuthFailure(getErrorEndOTP(e), msg));
  }
}

function* transferSaga() {
  yield all([takeLatest(FETCH_CHANGE_PASSWORD_REQUEST, fetchChangePasswordSaga)]);
  yield all([takeLatest(FETCH_CHANGE_PASSWORD_AUTH_REQUEST, fetchChangePasswordAuthSaga)]);
}

export default transferSaga;
